import { FC } from 'react'
import { Flex } from '@/components/atoms/Grid'
import styled from 'styled-components'
import { CheckIconDefault } from '../atoms/icons/CheckIconDefault'

type CheckBoxProps = {
  size: number
  isChecked: boolean
  isValid?: boolean
  onCheckboxClick: () => void
} & Rest

const CheckBox: FC<CheckBoxProps> = ({
  size,
  isChecked,
  onCheckboxClick,
  children,
  isValid = true,
  ...rest
}) => (
  <Flex
    cursorOnHover={true}
    alignItems="center"
    justifyContent="flex-start"
    onClick={onCheckboxClick}
    {...rest}
    data-testid="checkBox"
  >
    <CheckBoxElement
      flex="0 0 auto"
      mr="8px"
      width={size}
      height={size}
      isChecked={isChecked}
      isValid={isValid}
    >
      {isChecked && <CheckIconDefault />}
    </CheckBoxElement>
    {children}
  </Flex>
)

export default CheckBox

const CheckBoxElement = styled<CheckBoxProps>(Flex)`
  justify-content: center;
  border-radius: 4px;
  border: 1.5px solid
    ${(props) =>
      props.isValid
        ? props.theme.colors.onBackground
        : props.theme.colors.errorSecondary};
  background-color: ${(props) =>
    props.isChecked
      ? props.theme.colors.onBackground
      : props.theme.colors.background};
`
